"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PackageUnderstandingSkipCause = exports.PackageCreationOrigin = exports.PackageUnderstandingOutcome = exports.DatasheetContextKind = exports.DatasheetUrlDeadEnd = exports.DatasheetSearchSource = exports.DatasheetSearchOutcome = void 0;
var DatasheetSearchOutcome;
(function (DatasheetSearchOutcome) {
    DatasheetSearchOutcome["Found"] = "found";
    DatasheetSearchOutcome["NotFound"] = "not_found";
    DatasheetSearchOutcome["Failed"] = "failed";
})(DatasheetSearchOutcome || (exports.DatasheetSearchOutcome = DatasheetSearchOutcome = {}));
var DatasheetSearchSource;
(function (DatasheetSearchSource) {
    DatasheetSearchSource["Url"] = "url";
    DatasheetSearchSource["LinkedUrl"] = "linked_url";
    DatasheetSearchSource["Agent"] = "agent";
    DatasheetSearchSource["None"] = "none";
})(DatasheetSearchSource || (exports.DatasheetSearchSource = DatasheetSearchSource = {}));
var DatasheetUrlDeadEnd;
(function (DatasheetUrlDeadEnd) {
    DatasheetUrlDeadEnd["AccessDenied"] = "access_denied";
    DatasheetUrlDeadEnd["ConnectionFailed"] = "connection_failed";
    DatasheetUrlDeadEnd["NotFound"] = "not_found";
    DatasheetUrlDeadEnd["NotADatasheet"] = "not_a_datasheet";
    DatasheetUrlDeadEnd["ServerError"] = "server_error";
})(DatasheetUrlDeadEnd || (exports.DatasheetUrlDeadEnd = DatasheetUrlDeadEnd = {}));
var DatasheetContextKind;
(function (DatasheetContextKind) {
    DatasheetContextKind["Package"] = "package";
    DatasheetContextKind["ProjectModule"] = "project_module";
})(DatasheetContextKind || (exports.DatasheetContextKind = DatasheetContextKind = {}));
var PackageUnderstandingOutcome;
(function (PackageUnderstandingOutcome) {
    PackageUnderstandingOutcome["Completed"] = "completed";
    PackageUnderstandingOutcome["Autopublished"] = "autopublished";
    PackageUnderstandingOutcome["CatalogueOnlyNoDatasheet"] = "catalogue_only_no_datasheet";
    PackageUnderstandingOutcome["NotEligibleForAiExtraction"] = "not_eligible_for_ai_extraction";
    PackageUnderstandingOutcome["NeedsSubModels"] = "needs_sub_models";
})(PackageUnderstandingOutcome || (exports.PackageUnderstandingOutcome = PackageUnderstandingOutcome = {}));
var PackageCreationOrigin;
(function (PackageCreationOrigin) {
    PackageCreationOrigin["Ingestion"] = "ingestion";
    PackageCreationOrigin["Catalogue"] = "catalogue";
    PackageCreationOrigin["Manual"] = "manual";
    PackageCreationOrigin["Cli"] = "cli";
    PackageCreationOrigin["CustomerBomMerge"] = "customer_bom_merge";
    PackageCreationOrigin["Unknown"] = "unknown";
})(PackageCreationOrigin || (exports.PackageCreationOrigin = PackageCreationOrigin = {}));
var PackageUnderstandingSkipCause;
(function (PackageUnderstandingSkipCause) {
    PackageUnderstandingSkipCause["NoDatasheet"] = "no_datasheet";
    PackageUnderstandingSkipCause["DispatchFailed"] = "dispatch_failed";
    PackageUnderstandingSkipCause["NeverEvaluated"] = "never_evaluated";
    PackageUnderstandingSkipCause["DetailsUnavailable"] = "details_unavailable";
    PackageUnderstandingSkipCause["AlreadyRunning"] = "already_running";
})(PackageUnderstandingSkipCause || (exports.PackageUnderstandingSkipCause = PackageUnderstandingSkipCause = {}));
//# sourceMappingURL=package-milestone-enums.js.map